module.exports = __webpack_public_path__ + "static/media/tops.8bb154be.svg";